/* eslint-disable */
import styled from 'styled-components';
import SummarySection from 'ggApp/shared/components/Checkout/SummarySection';

export const Summary =  styled(SummarySection)`
    margin-bottom: ${props => props.theme.spacers.XL};
     ${props => props.theme.superQuery.all.and.maxWidth.mobileMax.css`
        margin-bottom: ${props => props.theme.spacers.L};
    `};
     
     & > div {
         ${props => `
            border-top: 2px solid ${props.theme.colors['Level 1']}
         `};
         margin-bottom: 0;
         padding: ${props => props.theme.spacers.L};
     }
`;
